import { Component, OnInit } from '@angular/core';
import { RouteValidationService } from "../../../../shared/route-validation.service";

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  host: { 'class': 'router-outlet' },
  // styleUrls: ['./security.component.scss']
})
export class SecurityComponent implements OnInit {
  selected: string = 'default';

  constructor(public routerValidationService: RouteValidationService) { }

  ngOnInit() {
    this.routerValidationService.selected$
      .subscribe(s => this.selected = s);
    this.routerValidationService.get();
  }

}
